import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "@/components/layouts/PageContainer";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import { Button } from "@/components/button";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { useCreateStudent } from "@/apis/users/createUser";
import type { ICreateStudentRequest } from "@/apis/users/createUser";
import StudentForm from "./components/StudentForm";

const UserCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const {
    mutate: createStudent,
    isPending,
    isError,
    error,
  } = useCreateStudent();
  const [serverError, setServerError] = useState<string | undefined>();

  // 폼 제출 핸들러
  const handleSubmit = (formData: ICreateStudentRequest) => {
    // API 호출
    createStudent(formData, {
      onSuccess: () => {
        // 성공 시 목록 페이지로 이동
        navigate("/users");
      },
      onError: (error: any) => {
        // 서버 오류 처리
        setServerError(error?.message || "Failed to create student");
      },
    });
  };

  // 목록 페이지로 돌아가기
  const handleCancel = () => {
    navigate("/users");
  };

  return (
    <PageContainer>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Button plain onClick={handleCancel}>
            <ArrowLeftIcon className="h-5 w-5" />
            Back
          </Button>

          <div>
            <Heading>Add New Student</Heading>
            <Text className="text-zinc-500">
              Fill in the information below to create a new student account.
            </Text>
          </div>
        </div>

        {/* 학생 생성 폼 */}
        <div className="p-8 border border-gray-200 rounded-md bg-white">
          <StudentForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isLoading={isPending}
            serverError={serverError}
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default UserCreatePage;
